import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash';
const ReturnReason = ({
  isChecked,
  onClick,
  title,
  description,
  isDisabled
}) => /*#__PURE__*/React.createElement("div", {
  className: "return-reason radio-button",
  onClick: !isDisabled ? onClick : undefined
}, /*#__PURE__*/React.createElement("input", {
  type: "radio",
  name: "ReturnReason",
  checked: isChecked,
  disabled: isDisabled,
  onChange: noop
}), /*#__PURE__*/React.createElement("label", {
  htmlFor: "radio-title",
  className: classNames('radio-label', {
    'radio-label--disabled': isDisabled
  })
}, /*#__PURE__*/React.createElement("p", {
  className: "radio-title"
}, title), description && /*#__PURE__*/React.createElement("p", {
  className: "radio-description",
  dangerouslySetInnerHTML: {
    __html: description
  }
})));
ReturnReason.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isChecked: PropTypes.bool,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool
};
export default ReturnReason;